import { render, staticRenderFns } from "./UploadImg.vue?vue&type=template&id=fbce70ac&scoped=true&"
import script from "./UploadImg.vue?vue&type=script&lang=js&"
export * from "./UploadImg.vue?vue&type=script&lang=js&"
import style0 from "./UploadImg.vue?vue&type=style&index=0&id=fbce70ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbce70ac",
  null
  
)

export default component.exports